import EnumConfig from './EnumConfig.jsx';

export default function RadioConfig({ field, onConfigChange }) {
  return <EnumConfig field={field} onConfigChange={onConfigChange} />;
}
